import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useMemberProfile } from "../MemberProfileContext";
import { OwnedField } from "./FormFields";
import { FormShell } from "./ProfileOverlayShell";
import type { FormProps } from "./types";

const adminFormSchema = z.object({
    trees: z.string(),
    kilograms: z.string(),
    squareMeters: z.string(),
});

type AdminFormValues = z.infer<typeof adminFormSchema>;

export function AdminForm({ onClose }: FormProps) {
    const { profile, saveAdmin } = useMemberProfile();
    const { control, handleSubmit } = useForm<AdminFormValues>({
        resolver: zodResolver(adminFormSchema),
        defaultValues: {
            trees: profile.admin.philanthropy
                ? String(profile.admin.philanthropy.trees)
                : "",
            kilograms: profile.admin.philanthropy
                ? String(profile.admin.philanthropy.kilograms)
                : "",
            squareMeters: profile.admin.philanthropy
                ? String(profile.admin.philanthropy.squareMeters)
                : "",
        },
    });

    function onSubmit(values: AdminFormValues) {
        saveAdmin(
            {
                contributions: {
                    trees: Number(values.trees) || 0,
                    kilograms: Number(values.kilograms) || 0,
                    squareMeters: Number(values.squareMeters) || 0,
                },
            },
            onClose,
        );
    }

    return (
        <FormShell title="Edit admin" onClose={onClose} onSave={handleSubmit(onSubmit)}>
            <OwnedField
                id="admin-trees"
                label="Trees"
                kind="number"
                control={control}
                name="trees"
            />
            <OwnedField
                id="admin-kilograms"
                label="Kilograms"
                kind="number"
                control={control}
                name="kilograms"
            />
            <OwnedField
                id="admin-square-meters"
                label="Squaremeters"
                kind="number"
                control={control}
                name="squareMeters"
            />
        </FormShell>
    );
}
